export const configData =  {  

    APP_URL: "https://devteamsmww.preferati.net/basic/web/api/",
    DOMAIN_URL: "https://devteamsmww.preferati.net/basic/web/",
    DRUPAL_APP_URL: "https://devsmww.preferati.net/api/",
    DRUPAL_DOMAIN_URL: "https://devsmww.preferati.net",
    AGENCY_DOMAIN_URL: "https://devsmwwagency.preferati.net",
    SCOUT_DOMAIN_URL: "https://devsmwwscout.preferati.net",
    GOOGLE_RECAPTCHA_SITE_KEY: '6LeGtQoTAAAAAC7f3LyY82WLCfOH66NMbs9f6eNv',
    DOMAIN_PUBLIC_URL: `${window.location.protocol}//${window.location.hostname}`
     }